import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { Plus, Trash2, Download, Power } from "lucide-react";
import { Modal } from "./Brands";

export default function QrCodes() {
  const [items, setItems] = useState([]);
  const [brands, setBrands] = useState([]);
  const [locations, setLocations] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ type: "brand", ref_id: "", label: "" });
  const [preview, setPreview] = useState(null);

  const load = () => api.get("/qrcodes").then((r) => setItems(r.data));
  useEffect(() => {
    load();
    api.get("/brands").then(r => setBrands(r.data));
    api.get("/locations").then(r => setLocations(r.data));
  }, []);

  const create = async (e) => {
    e.preventDefault();
    const r = await api.post("/qrcodes", form);
    setModal(null); setPreview(r.data); load();
  };

  const dlImage = (q) => {
    const a = document.createElement("a");
    a.href = q.png_b64;
    a.download = `qr-${q.tag}.png`;
    a.click();
  };

  const list = form.type === "brand" ? brands : locations;

  return (
    <Layout title="QR Codes" subtitle="Generator"
      action={<button className="btn-dark flex items-center gap-2" onClick={() => setModal("new")} data-testid="new-qr-btn"><Plus size={14} /> Generate QR</button>}>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
        <div className="lg:col-span-2 card-sharp">
          <table className="fin">
            <thead><tr><th>Tag</th><th>Type</th><th>Reference</th><th>Status</th><th></th></tr></thead>
            <tbody>
              {items.map((q) => (
                <tr key={q.id} className="cursor-pointer" onClick={() => setPreview(q)} data-testid={`qr-row-${q.id}`}>
                  <td className="font-mono text-[12px]">{q.tag}</td>
                  <td><span className="badge badge-gold">{q.type}</span></td>
                  <td>{q.ref_name || q.label}</td>
                  <td><span className={`badge badge-${q.status}`}>{q.status}</span></td>
                  <td className="text-right">
                    <button className="btn-outline mr-2" style={{padding:"6px 10px"}} onClick={(e) => { e.stopPropagation(); dlImage(q); }}><Download size={12} /></button>
                    <button className="btn-outline mr-2" style={{padding:"6px 10px"}} onClick={async (e) => { e.stopPropagation(); await api.patch(`/qrcodes/${q.id}/toggle`); load(); }}><Power size={12} /></button>
                    <button className="btn-outline" style={{padding:"6px 10px"}} onClick={async (e) => { e.stopPropagation(); if (confirm("Delete?")) { await api.delete(`/qrcodes/${q.id}`); load(); } }}><Trash2 size={12} /></button>
                  </td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan="5" className="text-center py-8 text-[#8C8C8C]">No QR codes yet.</td></tr>}
            </tbody>
          </table>
        </div>

        <div className="card-sharp p-6">
          <div className="label-tiny mb-2">Preview</div>
          {preview ? (
            <div data-testid="qr-preview">
              <div className="text-xl font-light mb-1" style={{fontFamily:"Outfit"}}>{preview.label}</div>
              <div className="text-[12px] text-[#8C8C8C] mb-4 font-mono">{preview.tag}</div>
              <div className="border border-[#E6E4E0] p-5 bg-white">
                <img src={preview.png_b64} alt="QR" className="w-full" />
              </div>
              <div className="text-[11px] text-[#8C8C8C] mt-4 break-all">{preview.deep_link}</div>
              <button className="btn-dark w-full mt-4 flex items-center justify-center gap-2" onClick={() => dlImage(preview)} data-testid="qr-download"><Download size={14} /> Download PNG</button>
            </div>
          ) : <div className="text-[#8C8C8C] text-sm">Select a QR from the list, or generate a new one.</div>}
        </div>
      </div>

      {modal && (
        <Modal onClose={() => setModal(null)} title="Generate QR code">
          <form onSubmit={create} className="space-y-4">
            <div>
              <div className="label-tiny mb-1.5">Type</div>
              <select className="fin" value={form.type} onChange={(e) => setForm({...form, type: e.target.value, ref_id: ""})} data-testid="qr-type">
                <option value="brand">Brand</option><option value="location">Location</option>
              </select>
            </div>
            <div>
              <div className="label-tiny mb-1.5">Select {form.type}</div>
              <select className="fin" required value={form.ref_id} onChange={(e) => setForm({...form, ref_id: e.target.value})} data-testid="qr-ref">
                <option value="">— choose —</option>
                {list.map((x) => <option key={x.id} value={x.id}>{x.name}</option>)}
              </select>
            </div>
            <div><div className="label-tiny mb-1.5">Label (optional)</div><input className="fin" value={form.label} onChange={(e) => setForm({...form, label: e.target.value})} /></div>
            <div className="flex justify-end gap-2 pt-2">
              <button type="button" className="btn-outline" onClick={() => setModal(null)}>Cancel</button>
              <button type="submit" className="btn-dark" data-testid="qr-generate-btn">Generate</button>
            </div>
          </form>
        </Modal>
      )}
    </Layout>
  );
}
